import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {} from "@heroicons/react/24/outline";
import React from "react";

function StudentSelectModal({
  children,
  title,
  open,
  setOpen,
  className,
  width,
}: any) {
  const cancelButtonRef = useRef(null);
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10 font-poppins md:hidden block"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto ">
          <div className="flex items-end min-h-full overflow-y-auto sm:p-0 ">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform  overflow-hidden  w-full rounded-t-lg  text-left shadow transition-all opacity-100 translate-y-0 sm:scale-100" ${
                  className && className.includes("max-w")
                    ? className
                    : "max-w-lg"
                }  `}
              >
                <div className={``}>
                  <div className="sm:flex sm:items-start ">
                    {/* <div className="mx-auto flex h-12 w-12 bg-[#ECEDFB] flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"> */}
                    {/* <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" /> */}
                    {/* </div> */}
                    <div className="w-full  relative">
                      <Dialog.Title
                        as="h3"
                        className="text-base font-semibold leading-6 text-gray-900 text-center"
                      >
                        {title}
                      </Dialog.Title>
                      <div className={"mx-auto " + className}>{children}</div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default StudentSelectModal;
